import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  doOtpRequest,
  // doSendMergeOtpRequest,
  doVerifyOtpAndMergeAccounts,
  doVerifyOtpRequest,
} from '../../../../store/action/auth';
import Button from '../../../../ui-core/Button/Button';
import { withRouter } from 'react-router';
import { APP_ROUTES, COURSES_SLUGS, getRoute } from '../../../../route';
import Counter from './Counter';
import { SEGMENT_EVENTS, trackSubmittedEvent } from '../../../../utils/Segment';
import { getUserAttribute } from '../../../../utils/helpers';
import { doPaymentInitiationRequest } from '../../../../store/action/products';
import { useCourseDetail } from '../../../../hooks/useCourseDetail';
// import { toggleShowGiftModal } from '../../../../store/action/gifts';
import { encodeBase64Value, encodeURLParams } from '../../../../utils/url';

import './style.css';
import { LOCAL_STORAGE_CONSTANT, MODAL_TYPE } from '../../../../constants/app';
import { extractJSON } from '../../../../services/jsonUtil';
import { getItem, removeItem, setItem } from '../../../../utils/cache';
import {
  doCreateOrderRequest,
  doOfflineCartRequest,
} from '../../../../store/action/checkout';
import {
  getCartInfoRequest,
  getCartInfoRequest2,
} from '../../../../api/checkout';
import { useModal } from '../../../../context/ModalContext';
// import { doCreateOrderRequest } from '../../../../store/action/checkout';

const OtpModal = props => {
  const [postData, setPostData] = useState({
    mobile: null,
    country_code: null,
    otp: null,
  });
  const socialLoginData = JSON.parse(localStorage.getItem('SocialLoginData'));
  const phoneDetails = JSON.parse(getItem('PhoneDetails'));

  const inputRef = useRef([]);
  const { user } = useSelector(state => state.auth);
  const initialState = new Array(4).fill('');
  const [otp, setOtp] = useState(initialState);
  const { isLoading } = useSelector(state => state.common);
  const { isLoading: loading } = useSelector(state => state.product);
  const userData = user;
  const numLen =
    user?.attributes?.mobile.toString().length ||
    phoneDetails?.mobile.toString().length ||
    socialLoginData?.mobile?.toString().length;
  const AccountMerge = getItem('AccountMerge');
  const mergePhoneDetails = JSON.parse(getItem('mergePhoneDetail'));
  const { handleModalState, history, match } = props;
  let maskInput = 'X';
  for (let i = 0; i < numLen - 5; i++) {
    maskInput = maskInput + 'X';
  }

  const subNum = (
    AccountMerge
      ? mergePhoneDetails?.mobile
      : user?.attributes?.mobile ||
        phoneDetails?.mobile ||
        socialLoginData?.mobile
  )
    ?.toString()
    ?.substring(numLen - 4, numLen + 1);
  const dialCode = AccountMerge
    ? mergePhoneDetails?.country_code
    : user?.attributes?.country_code || socialLoginData?.country_code;
  const dispatch = useDispatch();
  const isPayment = history.location.state?.payment || false;
  const { isLoading: challengeDetailLoading, handleCourseRedirection } =
    useCourseDetail(history, match);
  const [otpError, setOtpError] = useState(false);
  const urlParams = new URLSearchParams(history.location.search);
  const page = urlParams.get('page');
  const challengePages = Object.values(COURSES_SLUGS);
  const isChallengesPage = challengePages.includes(page);
  const [otpDisabled, setOtpDisabled] = useState(false);
  const { handleGlobalModalState } = useModal();
  const isAccountMerge = getItem('AccountMerge');
  const session = extractJSON(LOCAL_STORAGE_CONSTANT.SESSION);

  const OfflineCheckOut = JSON.parse(getItem('isOfflineCheckout'));
  const checkoutFromSignup = JSON.parse(
    localStorage.getItem('checkoutFromSignup'),
  );
  const isFromOtp = JSON.parse(getItem('isFromOtp'));

  useEffect(() => {
    let isMounted = true;
    setPostData({
      ...postData,
      mobile: userData?.attributes?.mobile || socialLoginData?.mobile,
      country_code:
        userData?.attributes?.country_code || socialLoginData?.country_code,
    });
    try {
      if (isMounted) {
        setOtp(initialState);
        if (inputRef.current[0] && inputRef.current[0]?.focus)
          inputRef.current[0].focus();
      }
    } catch (e) {
      if (isMounted) {
        throw e;
      }
    }
    return (isMounted = false);
  }, [userData]);

  const handleOtpChange = (element, index) => {
    if (element && isNaN(element.value)) return false;
    const otpData = [
      ...otp.map((d, idx) => (idx === index ? element.value : d)),
    ];

    if (element && otpData[index] !== '') {
      element.classList.add('filled');
    } else {
      element?.classList?.remove('filled');
    }
    setOtp(otpData);
    if (element.value) {
      setTimeout(() => {
        inputRef?.current[index + 1]?.focus();
      });
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.keyCode === 8) {
      setTimeout(() => {
        inputRef?.current[index - 1]?.focus();
        inputRef?.current[index - 1]?.select();
      }, 5);
    } else if (event.keyCode === 13 && otp.every(i => Boolean(i))) {
      handleOtpSubmit();
    }
  };

  const handleRedirectionForAlreadyOnboardedUser = (playbackHistory, plans) => {
    if (playbackHistory?.attributes?.source?.schedule_id) {
      const planId = playbackHistory?.attributes?.source?.id;
      const viewedPlan = plans.find(item => +item.id === +planId);
      const card_color = viewedPlan?.attributes?.card_color;
      const title = viewedPlan?.attributes?.title;
      const plan_type = playbackHistory?.attributes?.source?.plan_type;
      const searchParams = {
        card_color,
        title,
        plan_type,
      };
      if (viewedPlan) {
        if (viewedPlan?.attributes?.plan_type === 'plan') {
          const options = {
            pathParam: { id: planId },
            searchParam: {
              params: encodeURLParams(searchParams),
            },
          };
          const route = getRoute(APP_ROUTES.HOME_SUB_SECTION, options);
          history.push(route);
        } else {
          const options = {
            pathParam: { id: planId },
            searchParam: {
              params: encodeURLParams(searchParams),
            },
          };
          const route = getRoute(APP_ROUTES.PREMIUM_COURSES_DETAILS, options);
          history.push(route);
        }
      } else {
        history.push(APP_ROUTES.HOME);
      }
    } else {
      history.push(APP_ROUTES.HOME);
    }
  };

  const fetchCartData = async () => {
    return await getCartInfoRequest();
  };

  const fetchCartData2 = async () => {
    return await getCartInfoRequest2();
  };

  // JW-202, JW-190
  const handleCallback = async () => {
    const OfflineCartData = JSON.parse(getItem('offlineCart'));
    const completeOnboarding = extractJSON('completeOnboarding');
    const isOnboardingCompleted = getUserAttribute('onboarding_completed');

    if (OfflineCartData?.length) {
      for (const item of OfflineCartData || []) {
        const product = {
          ...item?.attributes,
          id: item?.attributes?.product_id,
        };

        await dispatch(doOfflineCartRequest({ product }));
        await new Promise(resolve => {
          setTimeout(resolve, 500);
        });
      }

      fetchCartData();
      fetchCartData2();
      dispatch(doCreateOrderRequest());
      removeItem('offlineCart');
      removeItem('checkoutFromSignup');
      removeItem('isOfflineCheckout');
    } else {
      const isRedirectCourse = getItem('redirectToCourse');
      if (isRedirectCourse && props?.handleClose) {
        props?.handleClose();
      } else if (completeOnboarding) {
        history.push(APP_ROUTES.ASSESSMENT_ONBOARDING);
      } else if (!isOnboardingCompleted) {
        history?.push(APP_ROUTES.SIGNUP_ONBOARDING);
      } else {
        history.push(APP_ROUTES.HOME);
      }
    }
  };

  const handleOtpSubmit = () => {
    const isFromLogin = getItem('isFromLogin');

    // Remove error class
    otp?.forEach((input, index) => {
      inputRef?.current[index]?.classList?.remove('error');
    });
    setOtpError(false); // Reset error

    if (isAccountMerge) {
      const payload = {
        type: 'mobile',
        mobile: mergePhoneDetails?.mobile,
        country_code: mergePhoneDetails?.country_code,
        code: otp.join(''),
      };
      dispatch(
        doVerifyOtpAndMergeAccounts({
          data: { ...payload },
          callback: () => {
            session.uid = (
              mergePhoneDetails?.country_code + mergePhoneDetails?.mobile
            ).slice(1);

            const uid = (
              mergePhoneDetails?.country_code + mergePhoneDetails?.mobile
            ).slice(1);

            const userLocal = extractJSON(LOCAL_STORAGE_CONSTANT.USER);

            let updatedUser;
            if (user) {
              updatedUser = {
                ...user,
                attributes: {
                  ...user?.attributes,
                  mobile: mergePhoneDetails?.mobile,
                  country_code: mergePhoneDetails?.country_code,
                },
              };
            } else {
              updatedUser = {
                ...userLocal,
                attributes: {
                  ...userLocal?.attributes,
                  mobile: mergePhoneDetails?.mobile,
                  country_code: mergePhoneDetails?.country_code,
                },
              };
            }

            setItem(
              LOCAL_STORAGE_CONSTANT.SESSION,
              JSON.stringify({ ...session, uid: uid }),
            );
            setItem(LOCAL_STORAGE_CONSTANT.USER, JSON.stringify(updatedUser));
            handleGlobalModalState(null);
            handleCallback();
            removeItem('AccountMerge');
            removeItem('mergePhoneDetail');
          },
          errorCallback: () => {
            handleModalState(MODAL_TYPE.OTP);
            otp?.forEach((input, index) => {
              inputRef?.current[index]?.classList?.add('error');
            });
            setOtpError(true);
          },
        }),
      );
    } else if (isFromLogin === 'true') {
      dispatch(
        doOtpRequest({
          data: { ...postData, otp: otp.join('') },
          callback: response => {
            if (isFromLogin === 'true') {
              const isPhoneLogin = getItem('isPhoneLogin');

              if (user?.attributes?.new_user) {
                trackSubmittedEvent(SEGMENT_EVENTS.USER_SIGNUP_SUCCESSFUL, {
                  user_id: user?.id,
                  has_access: user?.attributes?.has_access,
                  phone: user?.attributes?.mobile || socialLoginData?.mobile,
                  country_code:
                    user?.attributes?.country_code ||
                    socialLoginData?.country_code,
                });
              } else {
                trackSubmittedEvent(SEGMENT_EVENTS.USER_LOGIN_SUCCESSFUL, {
                  user_id: user?.id,
                  has_access: user?.attributes?.has_access,
                  phone: user?.attributes?.mobile || socialLoginData?.mobile,
                  country_code:
                    user?.attributes?.country_code ||
                    socialLoginData?.country_code,
                });
              }
              const new_user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
              const onboardingCompleted =
                user?.attributes?.onboarding_completed ||
                new_user?.attributes?.onboarding_completed;
              // if (onboardingCompleted) removeItem('completeOnboarding'); // commented for testing purpose

              if (isPhoneLogin === 'true') {
                if (
                  userData?.attributes?.email === null ||
                  userData?.attributes?.email === undefined ||
                  userData?.attributes?.email === '' ||
                  !userData?.attributes?.email.includes('@')
                ) {
                  handleModalState(MODAL_TYPE.ADD_EMAIL);
                } else {
                  // JW-299
                  if (
                    (OfflineCheckOut && isFromLogin) ||
                    (OfflineCheckOut && checkoutFromSignup) ||
                    (OfflineCheckOut && isFromOtp === 'isOtpModal')
                  ) {
                    processOfflineCart();
                    return;
                  }
                  handleModalState(null);
                  removeItem('AccountMerge');
                  removeItem('mergeEmailDetail');
                  removeItem('isPhoneLogin');
                  const isRedirectCourse = getItem('redirectToCourse');
                  if (isRedirectCourse && props?.handleClose) {
                    props?.handleClose();
                  } else {
                    history.push(APP_ROUTES.HOME);
                  }
                  // dispatch(
                  //   doSendMergeOtpRequest({
                  //     data: {
                  //       type: 'email',
                  //       email: userData?.attributes?.email,
                  //     },
                  //     callback: () => {
                  //       const emailDetails = {
                  //         email: userData?.attributes?.email,
                  //       };
                  //       setItem(
                  //         'mergeEmailDetail',
                  //         JSON.stringify(emailDetails),
                  //       );
                  //       handleModalState(MODAL_TYPE.EMAIL_OTP);
                  //     },
                  //   }),
                  // );
                }
              } else {
                const { playbackHistory, plans, payment } = response || {};
                if (match.path === APP_ROUTES.GIFTS) {
                  if (onboardingCompleted) {
                    // handleModalState(null);
                    if (isAccountMerge) {
                      handleGlobalModalState(null);
                    } else {
                      handleModalState(null);
                    }
                    // removeItem('completeOnboarding'); // commented for testing purpose
                    // dispatch(toggleShowGiftModal(true));
                  } else {
                    const url = getRoute(APP_ROUTES.FITNESS, {
                      searchParam: {
                        page: encodeBase64Value(APP_ROUTES.GIFTS),
                      },
                    });
                    history.push(url);
                    // handleModalState(null);
                    if (isAccountMerge) {
                      handleGlobalModalState(null);
                    } else {
                      handleModalState(null);
                    }
                  }
                } else if (
                  match.path === APP_ROUTES.PODCASTS ||
                  match.path === APP_ROUTES.BLOGS
                ) {
                  const route =
                    match.path === APP_ROUTES.PODCASTS ||
                    match.path === APP_ROUTES.BLOGS;
                  if (onboardingCompleted) {
                    // handleModalState(null);
                    if (isAccountMerge) {
                      handleGlobalModalState(null);
                    } else {
                      handleModalState(null);
                    }
                    // removeItem('completeOnboarding'); // commented for testing purpose
                    // dispatch(toggleShowGiftModal(true));
                  } else {
                    const url = getRoute(route, null);
                    history.push(url);
                    // handleModalState(null);
                    if (isAccountMerge) {
                      handleGlobalModalState(null);
                    } else {
                      handleModalState(null);
                    }
                  }
                } else if (
                  match.path === APP_ROUTES.COURSE_SLUG ||
                  isChallengesPage
                ) {
                  handleCourseRedirection();
                } else if (match.path === APP_ROUTES.THANK_YOU) {
                  // handleModalState('refetch');
                  if (isAccountMerge) {
                    handleGlobalModalState('refetch');
                  } else {
                    handleModalState('refetch');
                  }
                } else if (match.path === APP_ROUTES.COURSES) {
                  // handleModalState(null);
                  if (isAccountMerge) {
                    handleGlobalModalState(null);
                  } else {
                    handleModalState(null);
                  }
                  // removeItem('completeOnboarding'); // commented for testing purpose
                } else {
                  const subscriptionDetails = getUserAttribute(
                    'subscription_details',
                  );
                  const freeTrial = getUserAttribute('free_trial');
                  const isSubscriptionExpired = subscriptionDetails?.ends_at
                    ? new Date() > new Date(subscriptionDetails.ends_at)
                    : false;
                  const noSubscription = !subscriptionDetails?.subscribed;
                  const noFreeTrails = !freeTrial;
                  const noActiveSubscription = noSubscription
                    ? noFreeTrails
                    : false;
                  const isSubscriptionCancelled =
                    payment?.attributes?.provider === 'stripe' &&
                    payment?.attributes?.original_status === 'cancelled' &&
                    (payment?.attributes?.status === 'active' ||
                      payment?.attributes?.status === 'cancelled');
                  /*
                  when user comes into the app through public payment page or start free trial button
                  and has no active subscription / free trial or his subscription has expired
                  redirect to payment gateway
                */
                  if (
                    isPayment &&
                    (noActiveSubscription ||
                      isSubscriptionExpired ||
                      isSubscriptionCancelled)
                  ) {
                    if (!loading) {
                      dispatch(
                        doPaymentInitiationRequest({
                          callback: () => {
                            // handleModalState(null);
                            if (isAccountMerge) {
                              handleGlobalModalState(null);
                            } else {
                              handleModalState(null);
                            }
                          },
                          page: encodeBase64Value(APP_ROUTES.FREE_TRAIL),
                        }),
                      );
                    }
                  } else if (onboardingCompleted) {
                    handleRedirectionForAlreadyOnboardedUser(
                      playbackHistory,
                      plans,
                    );
                  } else {
                    history.push(APP_ROUTES.HOME, {
                      payment: true,
                    });
                  }
                }
              }
            } else {
              // handleModalState(MODAL_TYPE.ASSESSMENT);
              if (isAccountMerge) {
                handleGlobalModalState(MODAL_TYPE.ASSESSMENT);
              } else {
                handleModalState(MODAL_TYPE.ASSESSMENT);
              }
            }
            // const isRedirectCourse = getItem('redirectToCourse');
            // if (isRedirectCourse && props?.handleClose) {
            //   props?.handleClose();
            // }
          },
          errorCallback: () => {
            // handleModalState(MODAL_TYPE.OTP);
            if (isAccountMerge) {
              handleGlobalModalState(MODAL_TYPE.OTP);
            } else {
              handleModalState(MODAL_TYPE.OTP);
            }
            otp?.forEach((input, index) => {
              inputRef?.current[index]?.classList?.add('error');
            });
            setOtpError(true);
          },
          page: props.page,
          plan_id: props.plan_id,
        }),
      );
    } else {
      dispatch(
        doVerifyOtpRequest({
          data: { otp: otp.join('') },
          callback: () => {
            // handleModalState(MODAL_TYPE.ASSESSMENT);
            // JW-202, JW-190
            handleCallback();
            // removeItem('isPhoneVerified');
          },
          errorCallback: () => {
            handleModalState(MODAL_TYPE.OTP);
            otp?.forEach((input, index) => {
              inputRef?.current[index]?.classList?.add('error');
            });
            setOtpError(true);
          },
          page: props.page,
        }),
      );
    }
  };

  // JW-299
  const processOfflineCart = async () => {
    const OfflineCartData = JSON.parse(getItem('offlineCart'));
    if (OfflineCartData?.length) {
      for (const item of OfflineCartData || []) {
        const product = {
          ...item?.attributes,
          id: item?.attributes?.product_id,
        };

        await dispatch(doOfflineCartRequest({ product }));
        await new Promise(resolve => {
          setTimeout(resolve, 500);
        });
      }

      fetchCartData();
      fetchCartData2();
      dispatch(doCreateOrderRequest());
      removeItem('offlineCart');
      removeItem('checkoutFromSignup');
      removeItem('isOfflineCheckout');
    }
  };

  return (
    <div className="form-h">
      <h1 className="otp-h2 mb-3">Enter code</h1>
      <p className="sign-in-h3 mt-4 pb-2">
        Just one last step to verify your phone number
      </p>
      <div
        className="w-100 mt-3 mb-3"
        style={{ border: '0.5px solid #E3E3E6' }}
      ></div>
      <h3 className="otp-h3 text-center mb-0">
        Enter the verification code sent on your Mobile
      </h3>
      <h3 className="otp-h3 text-center">
        No.{' '}
        <span>
          {dialCode}
          {maskInput}
          {subNum}
        </span>
      </h3>
      <div className="otp-field-wrap d-flex align-items-center justify-content-evenly">
        {otp.map((data, index) => {
          return (
            <input
              inputMode="numeric"
              pattern="[0-9]*"
              className="otp-field"
              type="text"
              name="otp"
              placeholder="-"
              maxLength="1"
              key={index}
              value={data}
              onChange={evt => handleOtpChange(evt.target, index)}
              onFocus={evt => evt.target.select()}
              disabled={otpDisabled}
              onKeyDown={evt => handleKeyDown(evt, index)}
              ref={el => (inputRef.current[index] = el)}
            />
          );
        })}
      </div>
      <div className="text-center mt-0">
        {otpError && (
          <p style={{ color: '#EE4343' }}>You entered the wrong code</p>
        )}
      </div>
      <Counter
        page={props.page}
        postData={postData}
        otp={otp}
        setOtp={setOtp}
        setOtpDisabled={setOtpDisabled}
        handleModalState={handleModalState}
        fromPage={'otp'}
        inputRef={inputRef}
        setOtpError={setOtpError}
      />

      <Button
        // TODO: we need to add 'spinner-border text-white'
        class={`verify-button ${isLoading && ''}`}
        text="VERIFY"
        isDisabled={
          isLoading ||
          !otp.every(i => Boolean(i)) ||
          loading ||
          challengeDetailLoading
        }
        isLoading={isLoading || loading || challengeDetailLoading}
        onClick={() => handleOtpSubmit()}
      />
    </div>
  );
};

OtpModal.propTypes = {
  handleModalState: PropTypes.func,
  history: PropTypes.object,
  match: PropTypes.object,
  page: PropTypes.string,
  plan_id: PropTypes.string,
  handleClose: PropTypes.func,
};

export default withRouter(OtpModal);
